import * as angular from 'angular';
import ErrorView from './ErrorView.html';
import { ErrorController } from './ErrorController';
export const errorModule = angular
    .module('applicationError', [])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('applicationError', {
            url: '/error',
            template: ErrorView,
            controller: ErrorController,
            controllerAs: '$ctrl',
            params: {
                error: undefined,
            },
        });
    }])
    .name;
